export default __webpack_public_path__ + "static/media/downClouds.97aa4226.png";